/**
 * A stable colour per customer.
 *
 * Several orders from different customers sit side by side on these screens and
 * the job is to tell them apart at a glance — one badge colour for everybody
 * does not help with that. Derived from the name, so a customer keeps the same
 * colour on every screen and across sessions, with no palette to maintain.
 *
 * Shared rather than copied: two screens showing the same customer in two
 * different colours would be worse than no colour at all.
 */
const COLOURS = ['primary', 'success', 'info', 'warning', 'danger', 'secondary'];

export function clientColour(name) {
  const s = String(name || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return COLOURS[h % COLOURS.length];
}
